import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNyRettighet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0428 2.76172L9.10002 3.70453L12.725 7.32772L1 7.32836V8.66169L12.726 8.66072L9.10002 12.2855L10.0428 13.2283L14.8047 8.46643C15.0391 8.23212 15.0625 7.86678 14.875 7.60626L14.8047 7.52362L10.0428 2.76172Z",
		fill: "#AEB7E2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.5 14.5V8.5H1.8V14.5H1.5Z",
		stroke: "#AEB7E2"
	})]
});
export default SvgNyRettighet;
